module.exports = __webpack_public_path__ + "img/pic6.7725c515.png";